<template>
  <span v-if="!id" v-tooltip="text" :class="{ nowrap }">
    {{ text | cropString(max) }}
  </span>

  <a
    v-else
    @click.prevent.stop="openInNewTab({ name: routeName, params: { id, ...customParams } })"
  >
    <span
      v-tooltip="{ content: openTooltipList(text, max), html: true }"
      :class="{ nowrap }"
    >
      {{ text | cropString(max) }}
    </span>
  </a>
</template>

<script>
import listMixin from '@/mixins/ListMixin.vue'

export default {
  name: 'TableLinkCell',
  mixins: [listMixin],
  props: {
    text: {
      type: String,
      default: '',
    },
    id: {
      type: [String, Number],
      default: null,
    },
    routeName: {
      type: String,
      default: '',
    },
    max: {
      type: Number,
      default: 35,
    },
    customParams: {
      type: Object,
      default: () => ({}),
    },
    nowrap: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
a {
  color: #343434;
  border-bottom: 1px solid #efefef;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  vertical-align: bottom;
}
span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}
.nowrap {
  white-space: nowrap;
}
</style>
